import { sanitizeModel } from '@/common/utils/modelDecorator'
import { isPendingApproval } from '@/common/utils/users'

export default {
  computed: {
    usersModel() {
      return sanitizeModel({
        title: 'Users',
        endpoint: this.$appConfig.api.baseUrl + 'companies/users',
        allowNew: true,
        countrize: 'country_iso_code',
        fields: [
          {
            key: 'id'
          },
          {
            key: 'profile_picture',
            sortable: false,
            label: this.$gettext('Picture'),
            class: 'text-center',
            component: (value, key, item) => {
              return {
                is: 'img',
                src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',
                class: 'rounded',
                title: '<img src=data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII= style=\'background: transparent url(' + (item.profile_picture ? item.profile_picture.replace('=s96-c', '=s150-c') : 'https://www.gravatar.com/avatar/default?s=150&r=pg&d=mm') + ') no-repeat 50% 50%/cover;\' width=150 height=150 />',
                style: 'display: inline-block; width: 50px; height: 50px; background: transparent url(' + (item.profile_picture ? item.profile_picture.replace('=s96-c', '=s50-c') : 'https://www.gravatar.com/avatar/default?s=50&r=pg&d=mm') + ') no-repeat 50% 50%/cover;'
              }
            }
          },
          {
            key: 'name',
            sortable: true,
            editable: true,
            label: this.$gettext('Name'),
            component: (value, key, item) => {
              return {
                is: 'user-card',
                user: item,
                profilePicture: false,
                withTitles: false
              }
            }
          },
          {
            key: 'roles',
            label: this.$gettext('Roles and tags'),
            class: 'w-200',
            filter: 'allowedroles'
          },
          {
            key: 'email',
            editable: true,
            label: this.$gettext('Email')
          },
          {
            key: 'phone',
            label: this.$gettext('Phone')
          },
          {
            key: 'company_id',
            label: this.$gettext('Company')
          },
          {
            key: 'active',
            type: Boolean,
            editable: false,
            label: this.$gettext('Enabled'),
            class: 'text-center',
            // Rendered next to ApiList's enabled/disabled dot
            formatter: (value, key, item) => {
              if (!isPendingApproval(item)) return ''
              return `<span class="badge badge-warning ml-1" title="${this.$gettextInterpolate(this.$gettext('Waiting for %{brandName} approval'), { brandName: this.brandName })}">${this.$gettext('Pending approval')}</span>`
            }
          },
          {
            key: 'created_at',
            sortable: true,
            label: this.$gettext('Created At'),
            formatter: (value, key, item) => {
              return this.$options.filters.tabledatetime(value, this.$tz, this.frontConfig.i18n.moment)
            }
          },
          {
            key: 'updated_at',
            sortable: true,
            label: this.$gettext('Last Updated'),
            formatter: (value, key, item) => {
              return this.$options.filters.tabledatetime(value, this.$tz, this.frontConfig.i18n.moment)
            }
          }
        ],
        filters: [
          'id',
          'name',
          'email',
          'phone'
        ],
        exclude: [
          'id',
          'email',
          'phone',
          'company_id'
        ],
        includes: [
          'tags',
          'company.tags',
          'courier_available.tracking',
          'disabled_reason'
        ]
      })
    }
  }
}
